module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1178.10e5ae92.jpg";